<!-- <div class="card" style="height: 100%;">
  <div class="card-header d-flex justify-content-between">
    <h5 class="card-title"> Recent Invoices</h5> -->
<!-- </div> -->
<div class="tab-pane show active">
  <app-table-list [tableConfig]="tableConfig" [parentGetList]="getListData">
  </app-table-list>
  <div *ngIf="noDataFound" class="text-center text-muted mt-3">
    No data found.
  </div>
</div>
<div class="card-footer cursor-pointer mb-0"><a class="view-more" (click)="openInvoiceList()">more<i
      class="las la-angle-right" [ngStyle]="{'background-color':theme_color}"></i></a>
</div>
<!-- </div> -->